module.exports = __webpack_public_path__ + "img/journey-email-template-graphical.0eb45436.png";